import { useState, useEffect } from 'react';
import { FaTimes, FaEye, FaEyeSlash } from 'react-icons/fa';
import Select from 'react-select';
import { usersApi } from '../../api/users.api';
import toast from 'react-hot-toast';
import { userSchema, updateUserSchema } from '../../../../schemas/user.schema';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, Controller } from 'react-hook-form';
import { MODE } from '../../../../interaces/mode.interface';
import { STATUS } from '../../../../interaces/selects.interfaces';
import { updateDataWhenCreate, updateDataWhenUpdate } from '../../../../services/helpers';
import { useRoles } from '../../../roles/hooks/useRoles';
import { TOAST_SUCCESS_IDS, TOAST_ERROR_IDS } from '../../../../interaces/toast.ids.interface';
import { ENUM_ROLES, ENUM_ACTIONS } from '../../../../interaces/enums/enums.interface';
import { useRenapo } from '../../../interoperability/hooks/useRenapo';
function ModalUsers({ setEntities, onClose, model = null, mode = MODE.CREATE }) {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: zodResolver(mode == MODE.UPDATE ? updateUserSchema : userSchema),
    defaultValues: { status: true, role: 'FUNCIONARIO' },
  });
  const { user, getByCurp, setCurp, curp } = useRenapo();
  const { names: roles, getNames } = useRoles();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
  useEffect(() => {
    getNames();
  }, []);
  useEffect(() => {
    if (model && mode === MODE.UPDATE) {
      reset({
        curp: model.curp || '',
        rfc:model.rfc||'',
        username: model.username || '',
        name: model.name,
        firstLastName: model.firstLastName || '',
        secondLastName: model.secondLastName || '',
        email: model.email || '',
        password: '',
        passwordConfirmation: '',
        role: model.role || 'DESCONOCIDO',
        status: model.status !== undefined ? model.status : true,
      });
    } else {
      reset({
        curp: '',
        rfc:'',
        username: '',
        name: '',
        firstLastName: '',
        secondLastName: '',
        email: '',
        password: '',
        passwordConfirmation: '',
        role: ENUM_ROLES.GOVERNMENT_OFFICIAL,
        status: true,
      });
    }
  }, [mode, model, reset]);
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      if (mode === MODE.CREATE) {
        const response = await usersApi.create(data);
        updateDataWhenCreate(setEntities, response);
      } else {
        if (!data.password || data.password.trim() === '') {
          delete data.password;
          delete data.passwordConfirmation;
        }
        const response = await usersApi.update(model.id, data);
        updateDataWhenUpdate(setEntities, response);
      }
      toast.success(
        mode === MODE.CREATE
          ? TOAST_SUCCESS_IDS.RECORD_SAVED_SUCCESSFULLY
          : TOAST_SUCCESS_IDS.RECORD_UPDATED_SUCCESSFULLY,
        { id: TOAST_SUCCESS_IDS.RECORD_SAVED_SUCCESSFULLY }
      );
      onClose();
    } catch (error) {
      toast.error(error.message || TOAST_ERROR_IDS.SERVER_CONNECTION_ERROR);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (watch('curp') && watch('curp').length == 18 && mode == MODE.CREATE) setCurp(watch('curp'));
  }, [watch('curp')]);
  useEffect(() => {
    if (curp) getByCurp();
  }, [curp]);
  useEffect(() => {
    if (user && mode == MODE.CREATE) {
      setValue('name', user.name);
      setValue('firstLastName', user.firstLastName);
      setValue('secondLastName', user.secondLastName);
    }
  }, [user]);
  return (
    <div className="modal-overlay">
      <div className="modal-content modal-sizes">
        {/* Header */}
        <div className="modal-header">
          <h2 className="modal-title">
            {mode == MODE.UPDATE
              ? ENUM_ACTIONS.Update + 'Usuario'
              : ENUM_ACTIONS.Create + 'Usuario'}
          </h2>
          <button type="button" onClick={onClose} className="modal-close-btn">
            <FaTimes />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit(onSubmit)} className="modal-form">
          {/* Body */}
          <div className="modal-body">
            <div className="modal-div-columns">
              {/* CURP */}
              <div className="modal-div-column">
                <label className="label-base">
                  CURP  <p className="modal-input-required">*</p>
                </label>
                <input
                  type="text"
                  {...register('curp', {
                    onChange: (e) => (e.target.value = e.target.value.toUpperCase()),
                  })}
                  placeholder="Ingrese la CURP"
                  className="input-base"
                  maxLength={18}
                />
                {errors.curp && <span className="error-text">{errors.curp.message}</span>}
              </div>

              {/* Nombre(s) */}
              <div className="modal-div-column">
                <label className="label-base">Nombre(s) <p className="modal-input-required">*</p></label>
                <input
                  disabled={true}
                  type="text"
                  {...register('name')}
                  placeholder="Se llenara automaticamente"
                  className="input-base"
                />
                {errors.name && <span className="error-text">{errors.name.message}</span>}
              </div>

              {/* Apellidos */}
              <div className="modal-div-column">
                <label className="label-base">Primer apellido <p className="modal-input-required">*</p></label>
                <input
                  disabled={true}

                  type="text"
                  {...register('firstLastName')}
                  //placeholder="Ingrese el primer apellido"
                  placeholder="Se llenara automaticamente"

                  className="input-base"
                />
                {errors.firstLastName && (
                  <span className="error-text">{errors.firstLastName.message}</span>
                )}
              </div>
              <div className="modal-div-column">
                <label className="label-base">Segundo apellido <p className="modal-input-required">*</p></label>
                <input
                  disabled={true}

                  type="text"
                  {...register('secondLastName')}
                  placeholder="Se llenara automaticamente"
                  className="input-base"
                />
                {errors.secondLastName && (
                  <span className="error-text">{errors.secondLastName.message}</span>
                )}
              </div>
              <div className="modal-div-column">
                <label className="label-base">Rfc <p className="modal-input-required">*</p></label>
                <input
                  type="text"
                  {...register('rfc')}
                  placeholder="Ingresa tu rfc"
                  className="input-base"
                />
                {errors.rfc && <span className="error-text">{errors.rfc.message}</span>}
              </div>
              {/* Usuario */}
              <div className="modal-div-column">
                <label className="label-base">Usuario <p className="modal-input-required">*</p></label>
                <input
                  type="text"
                  {...register('username')}
                  placeholder="Ingresa el nombre de usuario"
                  className="input-base"
                />
                {errors.username && <span className="error-text">{errors.username.message}</span>}
              </div>
              {/* Correo Electrónico */}
              <div className="modal-div-column">
                <label className="label-base">Correo Electrónico <p className="modal-input-required">*</p></label>
                <input
                  type="email"
                  {...register('email')}
                  placeholder="correo@dominio.com"
                  className="input-base"
                />
                {errors.email && <span className="error-text">{errors.email.message}</span>}
              </div>
              {/* Rol */}
              <div className="modal-div-column">
                <label className="label-base">Rol <p className="modal-input-required">*</p></label>
                <Controller
                  name="role"
                  control={control}
                  render={({ field }) => (
                    <Select
                      options={roles}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.name}
                      value={roles.find((option) => option.name === field.value) || null}
                      onChange={(option) => field.onChange(option.name)}
                      isSearchable={false}
                      placeholder="Selecciona un rol"
                    />
                  )}
                />
                {errors.role && <span className="error-text">{errors.role.message}</span>}
              </div>

              {/* Contraseña */}
              <div className="modal-div-column">
                <label className="label-base">
                  {mode == MODE.UPDATE ? 'Nueva Contraseña (Opcional)' : 'Contraseña' }{mode==MODE.CREATE?<p className="modal-input-required">*</p>:''} 
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    {...register('password')}
                    placeholder={
                      mode == MODE.UPDATE
                        ? 'Dejar en blanco para mantener actual'
                        : 'Mín. 8 cars, mayúscula, número y símbolo'
                    }
                    className="input-base pr-12"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((visible) => !visible)}
                    aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                    className="btn-password"
                  >
                    {showPassword ? <FaEyeSlash size={17} /> : <FaEye size={17} />}
                  </button>
                </div>
                {errors.password && <span className="error-text">{errors.password.message}</span>}
              </div>

              {/* Confirmar Contraseña */}
              <div className="modal-div-column">
                <label className="label-base">
                  {mode == MODE.UPDATE ? 'Confirmar Nueva Contraseña' : 'Confirmar Contraseña'} {mode==MODE.CREATE?<p className="modal-input-required">*</p>:''} 
                </label>
                <div className="relative">
                  <input
                    type={showPasswordConfirmation ? 'text' : 'password'}
                    {...register('passwordConfirmation')}
                    placeholder={
                      mode == MODE.UPDATE ? 'Confirmar nueva contraseña' : 'Confirmar contraseña'
                    }
                    className="input-base pr-12"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPasswordConfirmation((visible) => !visible)}
                    aria-label={
                      showPasswordConfirmation ? 'Ocultar contraseña' : 'Mostrar contraseña'
                    }
                    className="btn-password"
                  >
                    {showPasswordConfirmation ? <FaEyeSlash size={17} /> : <FaEye size={17} />}
                  </button>
                </div>
                {errors.passwordConfirmation && (
                  <span className="error-text">{errors.passwordConfirmation.message}</span>
                )}
              </div>

              {/* Estatus */}
              <div className="modal-div-column">
                <label className="label-base">Estatus <p className="modal-input-required">*</p></label>
                <Controller
                  name="status"
                  control={control}
                  render={({ field }) => (
                    <Select
                      options={STATUS}
                      getOptionLabel={(option) => option.value}
                      getOptionValue={(option) => option.key}
                      value={STATUS.find((option) => option.key === field.value) || null}
                      onChange={(option) => field.onChange(option?.key === true)}
                      placeholder="Todos los Estatus"
                      isSearchable={false}
                    />
                  )}
                />
                {errors.status && <span className="error-text">{errors.status.message}</span>}
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button type="button" onClick={onClose} disabled={loading} className="btn-cancel">
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading || (mode == MODE.CREATE && !user)}
              className="btn-primary"
            >
              {loading ? 'Guardando...' : mode == MODE.UPDATE ? 'Actualizar' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModalUsers;
